import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControlLabel from '@mui/material/FormControlLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import TaskPropDialog from '../CreateDialogue/TaskVariableDialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import CustomSelect from "../CustomComponents/CustomSelect";
import { dateTransformation } from '../../utils.js'
import moment from "moment";
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import {logger,checkAuthentication} from '../../utils';

export default function EditPOProjecLabs({ handleLabsProjectsCallback, data }) {
    const timerRef = React.useRef(null);
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [ValueAlert, setAlert] = React.useState(false);
    const [alertText, setAlertText] = React.useState([]);
    const [LabPick, setLabPick] = React.useState([]);
    const [labList, setLabList] = React.useState([]);
    const [projectPick, setProjectPick] = React.useState([]);
    const [projectList, setProjectList] = React.useState([]);
    const [associate, setAssociate] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    //const [processData, setIsProcess] = React.useState();
    
    const initialValues = {             
        start: moment.utc(data.StartDate).format("MM/DD/YYYY"),
        end: moment.utc(data.EndDate).format("MM/DD/YYYY"),       
        IsActive: data.IsActive ? true : false,
        selectedProjects: [],
        selectedLabs: []
    };

    const validFormSchema = Yup.object({      
        
        start: Yup
            .date("Enter a starting date for the PO dd/mm/yyyy")
            .required("Starting date is required dd/mm/yyyy"),
        end: Yup
            .date("Enter an ending date for the PO dd/mm/yyyy")
            .required("Ending date is required dd/mm/yyyy"),       
        IsActive: Yup
            .boolean()

    })

    const onTrigger = React.useCallback((values) => {		
		var  start = moment.utc(values.start).format("MM/DD/YYYY");
        var end = moment.utc(values.end).format("MM/DD/YYYY");
        if ((!moment.utc(start).isSame(moment.utc(initialValues.start)) && !moment.utc(start).isBetween(moment.utc(initialValues.start), moment.utc(initialValues.end)))
            || (!moment.utc(end).isSame(moment.utc(initialValues.end)) && !moment.utc(end).isBetween(moment.utc(initialValues.start), moment.utc(initialValues.end)))) {
			var tempAlert = [];
			tempAlert.push(`L&P StartDate: ${start} and EndDate: ${end} should be in between PO (StartDate: ${initialValues.start} - EndDate: ${initialValues.end})`);
			setAlertText(tempAlert);
			setAlert(true);
			return;
		}
		
		
        let post = []
        if (LabPick.length && projectPick.length) {
            projectPick.map(p => {
                LabPick.map(l => {
                    post.push({

                        "Name": `${p.label}-${l.label}`,
                        "POID": data.ID,
                        "LabID": l.value,
                        "ProjectID": p.value,
                        "StartDate": moment.utc(values.start),
                        "EndDate": moment.utc(values.end),
                        "IsActive": values.IsActive
                   

                    })
                })
            })
            CheckBilled()
                .then(response => CheckCreate(response, post))
        }
        setLabPick([])
        setLabList([])
        setProjectPick([])
        setProjectList([])
        setAssociate([])
        setRefresh(true);
    })
    const CheckConflict = (lab, project) => {
        const response = fetch(`/api/PO/Associate/Check/${lab}/${project}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                return json;
            });
        return response;
    }

    const CheckBilled = async () => {
        const response = await fetch(`/api/PO/Associate/CheckBilled/${data.ID}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                return json;
            });
        return response;
    }

    const CheckCreate = (billList, list) => {
        logger('invoice', billList)
        logger('list', list)
        var conflict = false;
        var testList = []

        list.forEach((item, index) => {
            CheckConflict(item.LabID, item.ProjectID)
                .then(response =>
                    response.forEach((r, i) => {
                        if (moment.utc(item.EndDate).isBetween(r.StartDate, r.EndDate) || moment.utc(item.StartDate).isBetween(r.StartDate, r.EndDate)
                        || moment.utc(item.EndDate).isSame(moment.utc(r.EndDate)) || moment.utc(item.StartDate).isSame(moment.utc(data.StartDate))) {
                            //setAlertText(`Conflict`)
                            setAlert(true)
                            conflict = true
                            testList.push({ Name: item.Name, message: `It seems there is a Conflict for Start Date: ${moment.utc(item.StartDate).format("MM/DD/YYYY")} and End Date: ${moment.utc(item.EndDate).format("MM/DD/YYYY")}, Entered L&P (${item.Name}) already exists for that period`, Conflict: true })
                        } else if (moment.utc(r.StartDate).isBetween(item.StartDate, item.EndDate) || moment.utc(r.EndDate).isBetween(item.StartDate, item.EndDate)) {
                            setAlert(true)
                            conflict = true
                            testList.push({ Name: item.Name, message: `There is a Conflict with an Existing Invoice for Start Date: ${moment.utc(r.StartDate).format("MM/DD/YYYY")} and End Date: ${moment.utc(r.EndDate).format("MM/DD/YYYY")}, Please enter different time period`, Conflict: true })
                        } 
                        else if (moment.utc(item.StartDate) > moment.utc(item.EndDate)){
							setAlert(true)
                            conflict = true
                            testList.push({ Name: item.Name, message: `StartDate : ${moment.utc(item.StartDate).format("MM/DD/YYYY")} must be before the EndDate:  ${moment.utc(item.EndDate).format("MM/DD/YYYY")} to create an L&P: ${item.Name}`, Conflict: true })
                        } else {
                            testList.push({ Name: item.Name, message: ``, Conflict: false })
                        }
                    })
            )
        })

            billList.forEach((e, i) => {
                list.forEach((item, index) => {
                    logger('Invoice', e)
                    if (moment.utc(item.EndDate).isBetween(e.StartDate, e.EndDate) || moment.utc(item.StartDate).isBetween(e.StartDate, e.EndDate)) {
                        //setAlertText(`${e.InvoiceNumber}`)
                        setAlert(true)
                        conflict = true
                        testList.push({ Name: item.Name, message: ` ${item.Name} has a conflict with PO-${e.CommonName} on Invoice-${e.InvoiceNumber} `, Conflict: true })
                    } else if (moment.utc(e.StartDate).isBetween(item.StartDate, item.EndDate) || moment.utc(e.EndDate).isBetween(item.StartDate, item.EndDate)) {
                            //setAlertText(`Conflict`)
                            setAlert(true)
                            conflict = true
                            testList.push({ Name: item.Name, message: ` There is a Conflict with an Existing Invoice for Start Date: ${moment.utc(e.StartDate).format("MM/DD/YYYY")} and End Date: ${moment.utc(e.EndDate).format("MM/DD/YYYY")}, Please enter different time period`, Conflict: true })
                        } 
                    else if (moment.utc(item.StartDate) > moment.utc(item.EndDate)){
							setAlert(true)
                            conflict = true
                            testList.push({ Name: item.Name, message: `StartDate: ${moment.utc(item.StartDate).format("MM/DD/YYYY")} must be before the EndDate: ${moment.utc(item.EndDate).format("MM/DD/YYYY")} to create an L&P: ${item.Name}`, Conflict: true })
                    } else {
                        testList.push({ Name: item.Name, message: ``, Conflict: false })
                    }
                })
            })

        logger({ willSave: !conflict, testList: testList, add: billList.length + list.length })
        var tempAlert = []
        timerRef.current = setTimeout(() => {
            testList.forEach((test, index) => {
                if (test.Conflict) {
					if(tempAlert.indexOf(test.message)<0){
                   		tempAlert.push(test.message)
                   	}
                    list.splice(list.findIndex(l => l.Name == test.Name), 1);
                } 
            })
            setAlertText(tempAlert)
                logger(`this will be saved`, list)
                if(list.length>0){
	                fetch("/api/PO/Associate", {
	                    method: 'POST',
	                    headers: { 'Content-Type': 'application/json' },
	                    body: JSON.stringify({
	                        "Associate": list
	                    })
	                }).then(setRefresh(true));
	                setAlertText([]);
                }
        }, 1000);

    }

    const CheckEdit = async (billList, list) => {
        logger('invoice', billList)
        logger('list', list)
        var conflict = false;
        var testList = []

        list.forEach((item, index) => {
			if(item.IsActive == 1 && item.Edited == 1){
	            CheckConflict(item.labID, item.projectID)
	                .then(response =>
	                    response.forEach((r, i) => {
							const Name = item.Lab + "-" + item.project;
							
                            if (!moment.utc(item.StartDate).isSame(moment.utc(data.StartDate)) && !moment.utc(item.StartDate).isBetween(moment.utc(data.StartDate), moment.utc(data.EndDate))
                                || !moment.utc(item.EndDate).isSame(moment.utc(data.EndDate)) && !moment.utc(item.EndDate).isBetween(moment.utc(data.StartDate), moment.utc(data.EndDate))) {
								    conflict = true;
								    testList.push({
								        Name: Name,
								        message: `L&P StartDate: ${moment.utc(item.StartDate).format("MM/DD/YYYY")} and EndDate: ${moment.utc(item.EndDate).format("MM/DD/YYYY")} should be in between PO (StartDate: ${moment.utc(data.StartDate).format("MM/DD/YYYY")} - EndDate: ${moment.utc(data.EndDate).format("MM/DD/YYYY")})`,
								        Conflict: true,
								    });
								    //setAlert(true);
								}
							if (item.ID !== r.ID) {
								if (item.labID === r.labID && item.projectID === r.projectID &&
									(moment.utc(item.EndDate).isBetween(moment.utc(r.StartDate).subtract(1, 'days'), moment.utc(r.EndDate).add(1,'days')) || moment.utc(item.StartDate).isBetween(moment.utc(r.StartDate).subtract(1,'days'), moment.utc(r.EndDate).add(1,'days')))) {
									logger("list for each", moment(item.EndDate).isBetween(moment(r.StartDate), moment(r.EndDate)), moment(item.StartDate).isBetween(moment(r.StartDate), moment(r.EndDate)));
									conflict = true;
									testList.push({ Name: Name, message: `It seems there is a Conflict for Start Date: ${moment.utc(item.StartDate).format("MM/DD/YYYY")} and End Date: ${moment.utc(item.EndDate).format("MM/DD/YYYY")}, Entered L&P (${Name}) already exists for that period `, Conflict: true })
									//setAlert(true);
								} else if(moment.utc(item.StartDate)>(moment.utc(item.EndDate))){
									//alert("error");
	                    			conflict = true;
		                            testList.push({ Name: Name, message: `StartDate : ${moment.utc(item.StartDate).format("MM/DD/YYYY")} must be before the EndDate : ${moment.utc(item.EndDate).format("MM/DD/YYYY")} to edit L&P: ${Name}`, Conflict: true })
		                        	//setAlert(true);
		                        }
							} else if (item.ID === r.ID && moment.utc(item.StartDate).isAfter(moment.utc(item.EndDate))){
								conflict = true;
	                            testList.push({ Name: Name, message: `StartDate : ${moment.utc(item.StartDate).format("MM/DD/YYYY")} must be before the EndDate : ${moment.utc(item.EndDate).format("MM/DD/YYYY")} to edit L&P: ${Name}`, Conflict: true })
							}
							if(!conflict){
								testList.push({ Name: Name, message: ``, Conflict: false })
							}else{
								setAlert(true);
							}
							logger('Conflict', testList)
	                    })
	                )
	       }
        })

        billList.forEach((e, i) => {
            list.forEach((item, index) => {
				if(item.IsActive == 1 && item.Edited == 1){
					const Name = item.Lab + "-" + item.project;
	                if (moment.utc(item.EndDate).isBetween(e.StartDate, e.EndDate) || moment.utc(item.StartDate).isBetween(e.StartDate, e.EndDate))  {
						logger("list for each", moment.utc(item.EndDate).isBetween(e.StartDate, e.EndDate), moment.utc(item.StartDate).isBetween(e.StartDate, e.EndDate));
	                    //setAlertText(`${e.InvoiceNumber}`)
	                    setAlert(true)
	                    conflict = true
	                    testList.push({ Name: Name, message: ` ${Name} has a conflict with PO-${e.CommonName} on Invoice-${e.InvoiceNumber}`, Conflict: true })
	                }else if (moment.utc(e.StartDate).isBetween(item.StartDate, item.EndDate) || moment.utc(e.EndDate).isBetween(item.StartDate, item.EndDate)) {
                            //setAlertText(`Conflict`)
                            setAlert(true)
                            conflict = true
                            testList.push({ Name: item.Name, message: `There is a Conflict with an Existing Invoice for Start Date: ${moment.utc(e.StartDate).format("MM/DD/YYYY")} and End Date: ${moment.utc(e.EndDate).format("MM/DD/YYYY")}, Please enter different time period`, Conflict: true })
                        }  else if(moment.utc(item.StartDate)>moment.utc(item.EndDate)){
						setAlert(true)
	                    conflict = true
	                    testList.push({ Name: Name, message: `StartDate :${moment.utc(item.StartDate).format("MM/DD/YYYY")} must be before the EndDate : ${moment.utc(item.EndDate).format("MM/DD/YYYY")} to edit L&P: ${Name}`, Conflict: true })
                	} else {
						logger("billlse")
	                    testList.push({ Name: Name, message: ``, Conflict: false })
	                }
	            }
            })
        })

        logger({ willSave: !conflict, testList: testList, add: billList.length + list.length })
        var tempAlert = []
        timerRef.current = setTimeout(() => {
            testList.forEach((test, index) => {
                if (test.Conflict) {
					if(tempAlert.indexOf(test.message)<0){
                   		tempAlert.push(test.message)
                   	}
                    list.splice(list.findIndex(l => l.Name == test.Name), 1);
                }
            })
            setAlertText(tempAlert);
            //setAlert(true);
            logger(` Edit this will be saved`, list)
            if (!conflict) handleEdit();
            setRefresh(true);
        }, 1000);
    }

    const handleEdit = () => {
        logger(associate);
        fetch("/api/PO/Associate", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "Associate": associate
            })
        })
        setLabPick([])
        setLabList([])
        setProjectPick([])
        setProjectList([])
        setAssociate([])
        setRefresh(true);
    };

    const handleAlertClose = () => {
        setAlert(false);
        setAlertText([]);
    };

    const handleClickOpen = () => {
		setIsLoading(true);
        logger(data)
        setRefresh(true);
        setOpen(true);      
    };

    const handleClose = () => {
        setOpen(false);
        setLabPick([])
        setLabList([])
        setProjectPick([])
        setProjectList([])
        setAssociate([])
    };
	
	checkAuthentication();
	
    const setLabs = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
        setLabList(choices)
        
    }

    const setProjects = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
        setProjectList(choices)
    }

    const handleLabPick = (value) => () => {
        logger(value)
        const currentIndex = LabPick.indexOf(value);
        const newChecked = [...LabPick];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setLabPick(newChecked);
    }; 

    const handleProjectPick = (value) => () => {
        logger(value)
        const currentIndex = projectPick.indexOf(value);
        const newChecked = [...projectPick];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setProjectPick(newChecked);
    };

    const handleIsActiveChange = (index) => () => {
        const temp = [...associate]
        temp[index].IsActive = temp[index].IsActive ? 0 : 1
        temp[index].Edited = 1
        setAssociate(temp)
    };

    React.useEffect(() => {
		
		checkAuthentication();
        if (refresh) {
            fetch('api/lab/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setLabs(json))
            fetch('api/project/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setProjects(json))
            fetch(`/api/PO/Associate/${data.ID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setAssociate(json))
				.then(json => setIsLoading(false))
            setRefresh(false);
            //setIsLoading(false);
			
        }
    })

    return (
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Button variant="contained" onClick={handleClickOpen}>
                 L&P
            </Button>
            <Dialog open={open}
                onClose={handleClose}
                fullScreen
            >
                <DialogContent>

                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Edit labs & projects
                                        </Typography>
                                        <Button autoFocus color="inherit" onClick={(e) => {
                                            props.handleSubmit(e)
                                            setOpen(false)
                                        }}>
                                            Create/Close
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>PO: {data.CommonName}</DialogTitle>
                                <b>{data.IsAllProjects ? "Apply to All Projects" : ""}</b>
                                <div>
                                    <FormControl sx={{ m: 1, width: 160 }}>
                                        <TextField
                                            name="start"
                                            id="outlined-Start"
                                            type="date"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.start.indexOf("/") > 0 ? dateTransformation(props.values.start) : props.values.start}
                                            error={props.touched.name && Boolean(props.errors.start)}
                                            helperText={props.touched.start && props.errors.start}
                                            label="Start"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 160 }}>
                                        <TextField
                                            name="end"
                                            id="outlined-End"
                                            type="date"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.end.indexOf("/") > 0 ? dateTransformation(props.values.end) : props.values.end}
                                            error={props.touched.end && Boolean(props.errors.end)}
                                            helperText={props.touched.end && props.errors.end}
                                            label="End"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </FormControl>
                                </div> 
                                <div style={{ display: "flex" }}>
                                    <div>
                                    <Typography sx={{ ml: 2, flex: 1 }} variant="h7" component="div">
                                            Projects under this PO:
                                    </Typography>
                                    <div style={{ height: "450px", overflowY: "scroll" }}>
                                    <List dense sx={{ maxWidth: 200, bgcolor: 'background.paper' }}>
                                        {projectList.map((value) => {
                                            const labelId = `checkbox-list-secondary-label-${value}`;
                                            return (
                                                <ListItem
                                                    key={value.value}
                                                    secondaryAction={
                                                        <Checkbox
                                                            edge="end"
                                                            onChange={handleProjectPick(value)}
                                                            checked={projectPick.indexOf(value) !== -1}
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                        />
                                                    }
                                                    disablePadding
                                                >
                                                    <ListItemButton>
                                                        <ListItemText id={labelId} primary={value.label} />
                                                    </ListItemButton>
                                                </ListItem>
                                            );
                                        })}
                                        </List>

                                        </div>
                                    </div>
                                    <div>
                                    <Typography sx={{ ml: 2, flex: 1 }} variant="h7" component="div">
                                            Labs under this PO:

                                    </Typography>
                                    <div style={{ height: "450px", overflowY: "scroll" }}>
                                    <List dense sx={{ maxWidth: 200, bgcolor: 'background.paper' }}>
                                        {labList.map((value) => {
                                            const labelId = `checkbox-list-secondary-label-${value}`;
                                            return (
                                                <ListItem
                                                    key={value.value}
                                                    secondaryAction={
                                                        <Checkbox
                                                            edge="end"
                                                            onChange={handleLabPick(value)}
                                                            checked={LabPick.indexOf(value) !== -1}
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                        />
                                                    }
                                                    disablePadding
                                                >
                                                    <ListItemButton>
                                                        <ListItemText id={labelId} primary={value.label} />
                                                    </ListItemButton>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                        </div>
                                    </div>
                                    <div style={{ width: "50px"}}></div>
                                <div>
                                    <Typography sx={{ ml: 2, flex: 1 }} variant="h7" component="div">
                                            <Table sx={{ minWidth: 400 }} aria-label="simple table">
                                                <TableHead>
                                                    <div>
                                                        <TableCell style={{ width: '30%', align: 'left', colSpan: '3'}} >
                                                    <Button onClick={props.handleSubmit}>
                                                        Create
                                                    </Button>
                                                        </TableCell>
                                                        
                                                        <TableCell style={{ width: '30%', align: 'right' }}>
 
                                                            <Button onClick={() => {
                                                                CheckBilled()
                                                                    .then(response => CheckEdit(response, associate))
                                                            }}>            
                                                        Update
                                                            </Button>
                                                        </TableCell>
                                                    </div>
                                                    <TableRow>
                                                        <TableCell style={{ width: '15%' }}>Project</TableCell>
                                                        <TableCell style={{ width: '15%' }}>Lab</TableCell>
                                                        <TableCell style={{ width: '25%', align:'left' }} >StartDate</TableCell>
                                                        <TableCell style={{ width: '20%', align: 'center' }}>EndDate</TableCell>
                                                        <TableCell style={{ width: '10%', align: 'left' }}>Active</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                </TableBody>
                                                </Table>
                                    </Typography>
										<Grid container spacing={1} xs={4}>
											<Grid item xs={12}>
												{(isLoading) &&
													<FormControl sx={{ m: 1, height: 200, width: 300 }}>
														<InputLabel htmlFor="outlined-Name">L&P's</InputLabel>
														<Box sx={{
															display: 'flex',
															minHeight: 200,
															width: '100%',
															m: 1,
															border: 0,
															borderRadius: 0,
															alignContent: 'center'
														}}>
															<Fade
																in={(isLoading)}
																style={{
																	transitionDelay: !isLoading ? '800ms' : '0ms',
																}}
																unmountOnExit
															>
																<Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
																	
																	<CircularProgress color="secondary" />
																</Stack>
															</Fade>
														</Box>
													</FormControl>
												}
											</Grid>
										</Grid>
                                        <div style={{ height: "450px", overflowY: "scroll" }}>
                                        {(!isLoading) && <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 400, border: "2px solid gray" }} aria-label="simple table">
											<TableBody>
												{associate.map((value, index) => (
													<TableRow
														key={value.ID}
														sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
													>
														<TableCell component="th" scope="row">
															{value.project}
														</TableCell>
														<TableCell component="th" scope="row">
															{value.Lab}
														</TableCell>
														<TableCell align="right"><TextField
															name="start"
															id="Start"
															type="date"
															onBlur={props.handleBlur}
															value={moment.utc(value.StartDate).format("yyyy-MM-DD")}
															onChange={(e) => {
																let temp = [...associate]
																temp[index].StartDate = e.target.value
																temp[index].Edited = 1
																setAssociate(temp)
															}}
															inputFormat="dd-MM-yyyy"
															renderInput={(params) => <TextField {...params} helperText={null} />}
															label="Start"
														/></TableCell>
														<TableCell align="right">
															<TableCell align="right"><TextField
																name="end"
																id="End"
																type="date"
																onBlur={props.handleBlur}
																value={moment.utc(value.EndDate).format("yyyy-MM-DD")}
																onChange={(e) => {
																	let temp = [...associate]
																	temp[index].EndDate = e.target.value
																	temp[index].Edited = 1
																	setAssociate(temp)
																}}
																inputFormat="dd-MM-yyyy"
																renderInput={(params) => <TextField {...params} helperText={null} />}
																label="End"
															/></TableCell>
														</TableCell>
														<TableCell align="right">
															{value.index}
															<Checkbox
																checked={value.IsActive ? true : false}
																onChange={handleIsActiveChange(index)} />
														</TableCell>
													</TableRow>
												))}
											</TableBody>
										</Table>
                                        </TableContainer>
                                        }
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
                <Dialog
                    open={ValueAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"L&P Conflict"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {alertText.map((a, index) => {
								return(<p key={index}>{a}</p>)
								})}
			            </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            setAlert(false);
                            //setAlertText([]);
                        }} autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Dialog></MuiThemeProvider>
        </div>
    );
}